import { ReactNode, useLayoutEffect } from "react";
import SideBar from "@/components/SideBar";
import "@/components/Layout.css";

const Layout = ({
  children,
  hideBg,
}: {
  children: ReactNode;
  hideBg?: boolean;
}) => {
  const handlePageChange = () => {
    window.scrollTo(0, 0);
  };

  useLayoutEffect(() => {
    handlePageChange();
  }, []);

  return (
    <div className="main">
      <SideBar />
      <div className={hideBg ? "without-bg-image-content" : "content"}>
        {children}
      </div>
    </div>
  );
};

export default Layout;
